export const apiErrors = {
  error403Message: 'Access is denied. Please check your rights.',
  error404Message:
    'Sorry, the requested information could not be found or it is not available. Please check your request and try again',
  error500Message: 'Internal server error. Please try again later.',
  noResponseErrorMessage: 'No response from the server. Please try again later.',
  defaultErrorMessage: 'An error occurred while processing the request. Please try again later',
};
